import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Config } from '../models/config.model';
import { Injectable } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { UserModel } from '../models/auth/user.model';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

var httpHeaders: HttpHeaders;
@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public config: Config = {};
  public cargada = false;
  private url :string;
  private authLocalStorageData = 'data';

  public resource: any = {}; // MC CATFER-94

  constructor(private http:HttpClient) {
    
   }
   cargarConfig(){

    this.cargada = true;
 
   return fetch('./assets/configs/page.json')
   .then(response => response.json())
     .then(config => {
       this.cargada = true;
       this.config = config;
       this.url = this.config.servidor?.api_cart;
       this.getConfig().subscribe((resp) => {
         if(resp){
           this.config = resp;
         }
         
       });
     });
     
  }

  getConfig(){
   /*  const data = localStorage.getItem(this.authLocalStorageData)
    const authData : UserModel = JSON.parse(data!);
    const token = authData.token;
      httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      }); */
    const url = `${this.url}/config`;
    return this.http.get<Config>(url);
  }
  updateConfig(config: Config){
    const data = localStorage.getItem(this.authLocalStorageData)
    const authData : UserModel = JSON.parse(data!);
    const token = authData.token;
      httpHeaders = new HttpHeaders({
        Authorization: `Bearer ${token}`,
      });
    const url = `${this.url}/config`;
    return this.http.put<Config>(url, config, {headers: httpHeaders, observe: 'response'}).pipe(
      map(resp => resp),
      catchError( err => of(err) )
    );
  }

  // MC CATFER-94
  getResource(){
    return fetch('./assets/configs/resource.json')
    .then(response => response.json())
    .then((r)=>{
      this.resource = r;
    })
  }
}
